export default {
    currencyValue: "usd",
    signupButtonText: "signup.tryForFree",
    contactUsButtonText: "footer.contactUs",
    defaultSeatsIndex: 0
};
